module.exports = __webpack_public_path__ + "static/media/u-value-insulation.1c6389d9.png";